export const initialTransferForm = {
  fromSavingsAccountNumber: "",
  toMortgageAccountNumber: "",
  mortgageAmount: "",
  remarks: "",
};

export const LIMITS = {
  REMARKS_LIMIT: 100,
  REMARKS_MIN_LENGTH: 10,
  REMARKS_MAX_LENGTH: 100,
  SAVINGS_ACCOUNT_NUMBER_LENGTH: 10,
  MORTAGE_ACCOUNT_NUMBER_LENGTH: 10,
};
